import React, { createContext, useContext, useEffect, useState } from "react";

const ShareLoanContext = createContext();
export const useShareLoan = () => useContext(ShareLoanContext);

/**
 * This function creates a provider to post and share the selected loan to the loans provider (e.g Goodleap).
 * Components can access this providers data through the exposed useShareLoan context.
 * @callback shareLoanDTOCallback
 * @param {Object} payload Payload to send the backend to share loan to a loan provider
 * @param {shareLoanDTOCallback} shareLoanDTO Callback to send/share selected offer, pricing, and loan data to backend
 * @param {*} children Children of Provider
 * @returns {ShareLoanContext.Provider}
 */
export default function ShareLoanProvider({
  payload,
  shareLoanDTO,
  createUpdatedProposal,
  children,
}) {
  const [response, setResponse] = useState("");
  const [isLoading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [changeOrderMessage, setChangeOrderMessage] = useState(
    "Loading Change Order"
  );

  const updateLoanId = () => {
    if (response && response?.link) {
      window.open(response.link, "_blank");
      return;
    } else {
      setErrorMessage(response[0]?.description);
    }
  };

  const shareLoan = async () => {
    const ac = new AbortController();
    setLoading(true);
    try {
      // await createUpdatedProposal();
      const shareLoanResp = await shareLoanDTO(payload);
      if (shareLoanResp?.data) {
        setResponse(shareLoanResp?.data);
      }
      setSuccess(shareLoanResp?.success);
      if (shareLoanResp?.message) setChangeOrderMessage(shareLoanResp?.message);
      setErrorMessage(null);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setErrorMessage(error.message);
      return () => ac.abort();
    }
  };

  return (
    <ShareLoanContext.Provider
      value={{
        response,
        errorMessage,
        isLoading,
        changeOrderMessage,
        updateLoanId,
        shareLoan,
        success,
      }}
    >
      {children}
    </ShareLoanContext.Provider>
  );
}
